import { Button } from 'components/Button';
import { cx } from '@linaria/core';
import { makeUserFullName } from 'utils/users';
import { format } from 'date-fns';
import { avatar } from 'components/Navbar/components/Account/styles';
import { Avatar } from 'components/Avatar';
import { useAcceptOrgInvitation, useDeclineOrgInvitation } from '../JoinOrganization/hooks';
import { orgInviteWrapper } from './OrgInvitation.styles';

interface OrgInvitationCardProps extends React.HTMLAttributes<HTMLDivElement> {
  invitation: CF.API.Organizations.OrgMemberInvite;
  acceptInvitation: ReturnType<typeof useAcceptOrgInvitation>;
  declineInvitation: ReturnType<typeof useDeclineOrgInvitation>;
  className?: string;
  closeButton?: React.ReactNode;
}

export const OrgInvitationCard: React.FC<OrgInvitationCardProps> = ({
  invitation,
  acceptInvitation,
  declineInvitation,
  className,
  closeButton,
  ...props
}) => {
  const isBtnDisabled = acceptInvitation?.isLoading || declineInvitation?.isLoading;

  return (
    <div className={cx(orgInviteWrapper, className)} {...props}>
      <div className="title">
        <Avatar alt={`${invitation.organization.name} avatar`} userId={invitation.organization.id} className={cx('avatar', avatar)} />
        <h3>You have been invited to join {invitation.organization.name} organization</h3>
        {closeButton}
      </div>
      <p>
        {makeUserFullName(invitation.inviter as CF.API.Users.User)} has invited you to join as a {invitation.role.name}
      </p>
      <p>{format(new Date(invitation.created_at), 'EEE d LLL H:mm')}h.</p>
      <div className="button-group">
        <Button
          data-testid="org-invite-decline-btn"
          variant="tertiary"
          size="sm"
          disabled={isBtnDisabled}
          loading={declineInvitation.isLoading}
          onClick={() => declineInvitation.mutate(invitation)}
        >
          Decline
        </Button>
        <Button
          data-testid="org-invite-accept-btn"
          variant="primary"
          size="sm"
          disabled={isBtnDisabled}
          loading={acceptInvitation.isLoading}
          onClick={() => acceptInvitation.mutate(invitation)}
        >
          Accept
        </Button>
      </div>
    </div>
  );
};
